import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export const DropdownInput = (props) => {
  const {
    textBoxLabel,
    textBoxError,
    textBoxHelperText,
    ...otherProps
  } = props;

  return (
    <Autocomplete
      required
      fullWidth
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(op, selected) => op.value === selected.value}
      {...otherProps}
      renderInput={(params) => (
        <TextField
          {...params}
          label={textBoxLabel}
          error={textBoxError}
          helperText={textBoxHelperText}
        />
      )}
    />
  );
};
